import React from 'react';

import './success.css';

import { useTranslation } from 'react-i18next';

import { CheckIcon } from '../../assets/svg/CheckIcon';
import { formatNumberForDisplay } from '../../shared/utils';

export type SuccessTableItem = {
	amount: string;
	fundName: string;
};

export type SuccessTableProps = {
	items: SuccessTableItem[];
	total: string;
	symbol: string;
};

const SuccessTable: React.FC<SuccessTableProps> = ({ items, total, symbol }) => {
	const { t: translate } = useTranslation();
	return (
		<div className="success-table">
			{items.map(({ fundName, amount }) => (
				<div key={fundName} className="success-item">
					<CheckIcon className="success-item-icon" height="24" width="24" />
					<div className="success-item-info">
						<span className="success-item-fund">{fundName}</span>
						<span className="success-item-amount">
							{symbol}
							{formatNumberForDisplay(amount)}
						</span>
					</div>
				</div>
			))}
			<div className="success-table-footer">
				<span className="success-table-text">{translate('success.total')}</span>
				<span className="success-table-total">
					{symbol}
					{total}
				</span>
			</div>
		</div>
	);
};

export default SuccessTable;
